import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';

export type AssignablePlatformUserDto = {
  userId: string;
  name: string;
};

export type PlatformUserDto = {
  _id: string;
  userId: string;
  name: string;
  email: string;
  roleKey: string;
  googleId?: string;
  isActive: boolean;
  isSystemUser?: boolean;
  lastLoginAt?: string;
  createdAt?: string;
  updatedAt?: string;
  avatarUrl?: string;
};

export type CreatePlatformUserPayload = {
  name: string;
  email: string;
  roleKey: 'SUPER_ADMIN' | 'PLATFORM_STAFF' | 'COUNSELLOR';
};

export type UpdatePlatformUserPayload = {
  name: string;
  roleKey?: 'SUPER_ADMIN' | 'PLATFORM_STAFF' | 'COUNSELLOR';
};

@Injectable({ providedIn: 'root' })
export class PlatformUsersService {
  constructor(private readonly api: ApiService) {}

  list() {
    return this.api.get<ApiEnvelope<PlatformUserDto[]>>('platform/platform-users').pipe(map((r) => r.data));
  }

  listAssignable() {
    return this.api
      .get<ApiEnvelope<AssignablePlatformUserDto[]>>('platform/platform-users/assignable')
      .pipe(map((r) => r.data));
  }

  create(payload: CreatePlatformUserPayload) {
    return this.api
      .post<ApiEnvelope<PlatformUserDto>>('platform/platform-users', payload)
      .pipe(map((r) => r.data));
  }

  update(id: string, payload: UpdatePlatformUserPayload) {
    return this.api
      .patch<ApiEnvelope<PlatformUserDto>>(`platform/platform-users/${id}`, payload)
      .pipe(map((r) => r.data));
  }

  remove(id: string) {
    return this.api
      .delete<ApiEnvelope<{ deleted: boolean }>>(`platform/platform-users/${id}`)
      .pipe(map((r) => r.data));
  }
}
